var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddviewbudgeticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2689 28C27.5172 28 30.9931 24.5242 30.9931 20.2759C30.9931 16.0276 27.5172 12.5518 23.2689 12.5518C19.0207 12.5518 15.5448 16.0276 15.5448 20.2759C15.5448 24.5242 18.9241 28 23.2689 28ZM23.2689 14.4828C26.4552 14.4828 29.0621 17.0897 29.0621 20.2759C29.0621 23.4621 26.4552 26.069 23.2689 26.069C20.0827 26.069 17.4758 23.4621 17.4758 20.2759C17.4758 17.0897 19.9862 14.4828 23.2689 14.4828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1311 19.3106H24.2345V16.4141H22.3035V21.2416H27.1311V19.3106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.3793H13.7103V15.4483H6.75862V13.131L4.24828 10.6207H1.93103V6.75862H4.24828L6.75862 4.24828V1.93103H24.1379V4.24828L26.6483 6.75862H28.9655V12.5517H30.8966V0H0V17.3793ZM3.47586 12.5517L4.82759 13.9034V15.4483H1.93103V12.5517H3.47586ZM28.9655 4.82759H27.4207L26.069 3.47586V1.93103H28.9655V4.82759ZM4.82759 1.93103V3.47586L3.47586 4.82759H1.93103V1.93103H4.82759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3103 8.68922C19.3103 6.56508 17.5724 4.82715 15.4483 4.82715C13.3241 4.82715 11.5862 6.56508 11.5862 8.68922C11.5862 10.8134 13.3241 12.5513 15.4483 12.5513C17.5724 12.5513 19.3103 10.8134 19.3103 8.68922ZM13.5172 8.68922C13.5172 7.62715 14.3862 6.75818 15.4483 6.75818C16.5103 6.75818 17.3793 7.62715 17.3793 8.68922C17.3793 9.75129 16.5103 10.6203 15.4483 10.6203C14.3862 10.6203 13.5172 9.75129 13.5172 8.68922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5172 19.3105H0V21.2416H13.5172V19.3105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5172 23.1729H0V25.1039H13.5172V23.1729Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.9931,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddviewbudgeticon);
export default __webpack_public_path__ + "static/media/addviewbudgeticon.e44fcf91062463389de2560f8b661257.svg";
export { ForwardRef as ReactComponent };